import { Common } from '@stockbit/ui';
import { Checkbox } from '../../styled';
import { AllStockButton, Wrapper } from './styled';
import { RunningTradeStockFilter, StockFilterTypeEnum } from '../../../types';

const { Text } = Common;

interface IAllStock {
  isChecked: boolean;
  setFilter: (value: RunningTradeStockFilter) => void;
}

const AllStock = ({
  isChecked,
  setFilter,
}: IAllStock) => {
  const onCheck = () => {
    setFilter({
      type: StockFilterTypeEnum.AllStock,
    });
  };

  return (
    <Wrapper onClick={onCheck}>
      <AllStockButton px="16px" py="8.5px">
        <Text weight="700">
          All Stocks
        </Text>
        <Checkbox checked={isChecked} />
      </AllStockButton>
    </Wrapper>
  );
};

export default AllStock;
